export default __webpack_public_path__ + "static/media/icon.32cc22c3.png";